// What the student's top bar needs to know about a path. TopNav (college students) and
// StudentDesk/shell/DeskTopBar (everyone else) read the same list.

// Best-guess page title from URL when the page hasn't called setPageTitle.
const PATH_TITLES = [
  ['/s/dashboard', 'Dashboard'],
  ['/s/chat', 'Batch Chat'],
  ['/s/learning', 'My Learning'],
  ['/s/materials', 'Study Materials'],
  ['/s/assignments', 'Assignments'],
  ['/s/practice', 'Coding Practice'],
  ['/s/assessments', 'Quizzes & Tests'],
  ['/s/test-series', 'Test Series'],
  ['/s/attendance', 'My Attendance'],
  ['/s/mock-interview', 'Mock Interview'],
  ['/s/learn-with-ai', 'Learn with AI'],
  ['/s/fees', 'My Fees'],
  ['/s/interviews', 'Interviews'],
  ['/s/calendar', 'Calendar'],
  ['/s/self-paced', 'Self-Paced'],
  ['/s/courses', 'Courses'],
  ['/s/feedback', 'Feedback'],
  ['/s/support', 'Support'],
  ['/s/account-settings', 'Account Settings'],
];

export const titleForPath = (pathname) => {
  for (const [prefix, label] of PATH_TITLES) {
    if (pathname.startsWith(prefix)) return label;
  }
  return '';
};

// Top-level student destinations — the section roots reachable directly from
// the sidebar. These keep their page header in the top nav (portaled by
// PageHeader) and have no back button (there's nowhere "up" to go). Deeper
// pages (detail / session / player routes such as /s/courses/:id,
// /s/self-paced/:id/learn, /s/mock-interview/:id, /s/watch-v2/:id) fall
// through: they render their own header + back button in the page body, so the
// top nav stays clear of a duplicate header/back. Match is exact, not prefix,
// because e.g. /s/courses is top-level while /s/courses/:id is a detail page.
export const STUDENT_TOP_LEVEL = new Set([
  '/s/dashboard',
  '/s/chat',
  '/s/learning',
  '/s/courses',
  '/s/courses/my-requests',
  '/s/self-paced',
  '/s/self-paced/enrollments',
  '/s/self-paced/certificates',
  '/s/compliance',
  '/s/mock-interview/setup',
  '/s/mock-interview/history',
  '/s/learn-with-ai',
  '/s/learn-ai/history',
  '/s/fees',
  '/s/practice',
  '/s/assignments',
  '/s/interviews',
  '/s/assessments',
  '/s/test-series',
  '/s/attendance',
  '/s/feedback',
  '/s/calendar',
  '/s/support',
  '/s/account-settings',
]);

/** AIvo stays out of the live classroom and of focus-critical learning flows. */
export const hidesAssistant = (path) => (
  path.startsWith('/s/classroom/')
  || path.startsWith('/s/practice/')
  || path.startsWith('/s/assessment/take/')
  || path.startsWith('/s/mock-interview/')
  || path.startsWith('/s/learn-with-ai')
  || path.startsWith('/s/learn-ai/')
);
